export type PageContext = { url: string; title: string; text: string };

// Builds a self-contained, model-facing context block describing the web page the
// user is currently viewing. Returns null when there is nothing useful to send.
export function buildPageContextString(pageContext: PageContext | null): string | null {
	if (!pageContext) return null;
	const url = pageContext.url?.trim() ?? '';
	const title = pageContext.title?.trim() ?? '';
	const text = pageContext.text?.trim() ?? '';
	if (!url && !title && !text) return null;

	const lines: string[] = [
		'The user is currently viewing a web page in their browser. Use it as context only if it helps answer their message; do not mention it otherwise.'
	];
	if (url) lines.push(`URL: ${url}`);
	if (title) lines.push(`Page title: ${title}`);
	if (text) lines.push(`Visible page text (may be truncated):\n${text}`);
	return lines.join('\n');
}
